import React, { useContext } from 'react';
import './Event.css';
import ModuleLoadingStatus from '../ModuleLoadingStatus/ModuleLoadingStatus';
import { CardNextEventContext } from '../../contexts/CardNextEventContext';
import logComponent from '../../common/logComponent';

export default function EventLoadingStatus({ reloadAction }) {
  const cardNextEventContext = useContext(CardNextEventContext);
  const { eventLoading, eventError } = cardNextEventContext;

  if (logComponent('EventLoadingStatus')) { console.debug('EventLoadingStatus rendered'); }


  return (
    <ModuleLoadingStatus isLoading={eventLoading} isError={eventError} reloadAction={reloadAction} />
  );
}